'use client';

import React, { useState } from 'react';
import dynamic from 'next/dynamic';
import { Navbar } from '@/components/landing/Navbar';
import { Hero } from '@/components/landing/Hero';
import JsonLd from '@/components/seo/JsonLd';

const FeatureGrid = dynamic(() => import('@/components/landing/FeatureGrid').then(m => m.FeatureGrid), { loading: () => <div className="h-96" /> });
const TheBrain = dynamic(() => import('@/components/landing/TheBrain').then(m => m.TheBrain), { loading: () => <div className="h-96" /> });
const Integrations = dynamic(() => import('@/components/landing/Integrations').then(m => m.Integrations), { loading: () => <div className="h-64" /> });
const AutopilotSection = dynamic(() => import('@/components/landing/AutopilotSection').then(m => m.AutopilotSection), { loading: () => <div className="h-96" /> });
const PricingTable = dynamic(() => import('@/components/landing/PricingTable').then(m => m.PricingTable), { loading: () => <div className="h-96" /> });
const TweetCarousel = dynamic(() => import('@/components/marketing/tweet-carousel').then(m => m.TweetCarousel));
const CTA = dynamic(() => import('@/components/landing/CTA').then(m => m.CTA));
const Footer = dynamic(() => import('@/components/landing/Footer').then(m => m.Footer));
const DemoModal = dynamic(() => import('@/components/DemoModal'));

export default function LandingPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);

  const softwareSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Axist',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Cloud',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Start for free with limited features'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      ratingCount: '120',
      bestRating: '5',
      worstRating: '1'
    },
    featureList: [
      'AI Marketing Agents',
      'Agent-to-Agent Coordination (The Brain)',
      'Automated Ad Management',
      'Content Generation',
      'Lead Discovery',
      'Voice AI Receptionist',
      '100+ Integrations via Composio',
      'Autopilot Revenue Engine'
    ]
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] text-neutral-900 font-sans selection:bg-orange-100 selection:text-orange-900">
      <JsonLd data={softwareSchema} />
      <Navbar onDemoClick={() => setIsDemoModalOpen(true)} />

      <main>
        {/* 1. Hero */}
        <Hero />
        {/* 2. Platform Hubs — Campaigns, Creative, Inbox */}
        <FeatureGrid />
        {/* 4. The Brain — agent coordination + revenue pipeline */}
        <TheBrain />
        {/* 5. Integrations — 100+ app logos */}
        <Integrations />
        {/* 6. Autopilot Trust — Manual → Copilot → Full Autopilot */}
        <AutopilotSection />
        {/* 7. Social Proof */}
        <TweetCarousel />
        {/* 9. CTA */}
        <CTA />
      </main>

      <Footer />

      <DemoModal
        isOpen={isDemoModalOpen}
        onClose={() => setIsDemoModalOpen(false)}
      />
    </div>
  );
}